
import { Vue, Options } from "vue-class-component";
import checkRolePermission from "@/app/infrastructures/misc/common-library/CheckRolePermission";
import ellipsisString from "@/app/infrastructures/misc/common-library/EllipsisString";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BaggingController } from "@/app/ui/controllers/BaggingController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { OUTGOING_SHIPMENT_BAGGING } from "@/app/infrastructures/misc/RolePermission";
import Print from "./modules/print.vue";
import debounce from "lodash/debounce";
import EmptyState from "@/app/ui/components/empty-list/index.vue";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import {
  BaggingData,
  PayloadUpdateReadyToCargo,
  BaggingRTCSttsFailedResponse
} from "@/domain/entities/Bagging";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import Checkbox from "primevue/checkbox";
import { flags } from "@/feature-flags";
import formatValueNumber from "@/app/infrastructures/misc/common-library/FormatValueNumber";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";
import XLSX from "xlsx";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import MultipleSelect from "@/app/ui/components/multiple-select/index.vue";
import { HubController } from "@/app/ui/controllers/HubController";
import { RequestHubList } from "@/domain/entities/Hub";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import DisputeSummary from "./component/dispute-summary.vue";
import { FlagsPermissionBagging } from "@/feature-flags/flags-permission-bagging";
import moment from "moment";

/* eslint-disable @typescript-eslint/camelcase */
@Options({
  components: {
    Print,
    EmptyState,
    Checkbox,
    MultipleSelect,
    DisputeSummary
  },
  computed: {
    getTitle() {
      return this.$t("Proses BAG");
    },
    ableToCreate() {
      return checkRolePermission(OUTGOING_SHIPMENT_BAGGING.CREATE);
    },
    ableToDetail() {
      return checkRolePermission(OUTGOING_SHIPMENT_BAGGING.DETAIL);
    }
  },
  directives: {
    "click-outside": {
      beforeMount: function(el, binding) {
        const ourClickEventHandler = (event: any) => {
          if (!el.contains(event.target) && el !== event.target) {
            binding.value(event);
          }
        };
        el.__vueClickEventHandler__ = ourClickEventHandler;
        document.addEventListener("click", ourClickEventHandler);
      },
      unmounted: function(el) {
        document.removeEventListener("click", el.__vueClickEventHandler__);
      }
    }
  }
})
export default class Bagging extends Vue {
  get isShowRTC() {
    const allowedCountry = ["ID", "MY"].includes(
      AccountController.accountData.countryCode.toUpperCase()
    );

    return flags.feature_rtc_bagging_enabled.isEnabled() && allowedCountry;
  }

  get isAccountForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  refs: any = this.$refs;
  mounted() {
    this.refs = this.$refs;
    if (getHubData()?.hubId) {
      BaggingController.setHubIdSelected([
        { label: getHubData()?.hubName, value: getHubData()?.hubId }
      ]);
      this.hubIdSelected = [
        { label: getHubData()?.hubName, value: getHubData()?.hubId }
      ];
    }
    this.getHubList();
  }

  unmounted() {
    this.clearSearch();
    BaggingController.setHubIdSelected([]);
  }

  // multiple select
  hubIdSelected: any = BaggingController.hubIdSelected;
  hubIdOptions: any = [];

  async getHubList() {
    await HubController.getHubList(
      new RequestHubList({
        city:
          AccountController.accountData.account_type_detail?.partnerLocation
            ?.city_code,
        status: "active",
        partnerId: AccountController.accountData.account_type_detail?.id
      })
    ).then((res: any) => {
      this.hubIdOptions = res.data.map((item: any) => ({
        label: item.hubName,
        value: item.hubId
      }));
    });
  }

  onChangeHubIdSelected() {
    BaggingController.setHubIdSelected(this.hubIdSelected);
    this.fetchBaggingList();
  }

  showModalSTTPaid = false;
  handlerModalSTTPaid(val: boolean) {
    this.showModalSTTPaid = val;
  }

  isRTC = false;

  // time-range-picker
  minDate: any = null;
  maxDate: any = null;
  tempPeriodeStart: any = null;
  tempPeriodeEnd: any = null;
  isStartDate = true;
  setDay(day: any) {
    if (this.isStartDate) {
      this.tempPeriodeStart = this.periodeStart;
      this.tempPeriodeEnd = this.periodeEnd;
      BaggingController.setPeriodeStart(null);
      BaggingController.setPeriodeEnd(null);
      this.isStartDate = false;
    } else {
      this.periodeEnd && (this.isStartDate = true);
    }
  }

  cancelRangePick() {
    if (!this.isStartDate) {
      this.minDate = null;
      this.maxDate = null;
      BaggingController.setPeriodeStart(this.tempPeriodeStart);
      BaggingController.setPeriodeEnd(this.tempPeriodeEnd);
      this.tempPeriodeStart = null;
      this.tempPeriodeEnd = null;
      this.isStartDate = true;
    }
  }

  fetchBaggingList() {
    BaggingController.fetchBaggingList();
    this.readyToDelete = [];
    this.readyToProcess = [];

    this.fetchDisputeSummaryData();
  }

  fetchDisputeSummaryData() {
    BaggingController.fetchDisputeSummary();
  }

  // notification
  get notificationsData() {
    return BaggingController.responseCreate.data;
  }

  // loading
  get isLoading() {
    return BaggingController.isLoading;
  }

  // error cause
  get errorCause() {
    return BaggingController.errorCause;
  }

  // filter date
  get periodeStart() {
    return BaggingController.periodeStart;
  }

  get periodeEnd() {
    return BaggingController.periodeEnd;
  }

  setDateRange(value: Array<any>) {
    this.minDate = null;
    this.maxDate = null;
    BaggingController.setPeriodeStart(value[0]);
    BaggingController.setPeriodeEnd(value[1]);
    this.$nextTick().then(() => {
      value[0] && value[1] && this.fetchBaggingList();
    });
  }

  // filter search
  get searchValue() {
    return BaggingController.filter.search;
  }

  onSearch = debounce((val: string) => {
    BaggingController.setSearch(val);
    this.fetchBaggingList();
  }, 250);

  clearSearch() {
    BaggingController.setSearch("");
    this.fetchBaggingList();
  }

  // goToCreate
  goToCreate() {
    this.$router.push("/bagging/create");
    this.handlerModalSTTPaid(false);
    dataLayer("buat_bagging_click", {}, ["userId", "username", "userType"]);
    dataLayer("page_view", { detail_bagging_form: "" }, []);
  }

  ellipsisString(value: string) {
    return ellipsisString(value, 15);
  }

  // Table

  get account() {
    return AccountController.accountData;
  }

  get columns() {
    return [
      {
        name: "No.",
        styleHead: "w-12 text-left whitespace-no-wrap",
        render: (item: BaggingData, index: any) => {
          return `<div class="overflow-ellipsis text-left">${index +
            1 +
            this.pagination.limit * (this.pagination.page - 1)}</div>`;
        }
      },
      {
        name: "No. Bag",
        styleHead: "w-50 text-left whitespace-no-wrap",
        key: "actionable_column",
        validateIcon: true,
        showIcon: (item: BaggingData) => item.isDisputeBagging,
        showButton: () => true,
        icon: "kg-dispute",
        iconStyle: "ml-1 h-4",
        iconColor: "red-lp-100",
        iconTooltip: () => this.$t('bagging.bagWithWeightDispute'),
        generateId: (_: BaggingData, index: number) =>
          `lp-bagging-list-bag-code-dispute-icon-${index}`,
        render: (item: BaggingData) => {
          return `<div class="overflow-ellipsis text-left">${item.bagCode}</div>`;
        }
      },
      {
        name: "Total STT",
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="overflow-ellipsis text-left" data-testid="outgoing-bagging-total-stt">${formatByCountry(item.bagTotalStt, { type: "quantity" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.tableTitle.totalPieces"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="overflow-ellipsis text-left">${formatByCountry(item.bagTotalPiece, { type: "quantity" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.tableTitle.totalSTTDG"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="overflow-ellipsis text-left">${formatByCountry(item.totalSttDgCount, { type: "quantity" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.beratBagDikenakanBiaya"),
        styleHead: "w-64 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="overflow-ellipsis text-left">${formatByCountry(item.bagCustomChargeableWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.totalBeratKotorBag"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="overflow-ellipsis text-left" data-testid="outgoing-bagging-total-gross-weight">${formatByCountry(item.bagCustomGrossWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.totalBeratVolumeBag"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="overflow-ellipsis text-left">${formatByCountry(item.bagCustomVolumeWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.dibuatOlehHub"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="break-all text-left">${this.ellipsisString(
            item.bagHubName
          ) || "-"}</div>`;
        }
      },
      {
        name: this.$t("bagging.tableTitle.destinationType"),
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="overflow-ellipsis text-left">${item.bagDestinationCityCode} - ${item.bagDestinationCityName}</div>`;
        }
      },
      {
        name: this.$t("bagging.tableTitle.createdBy"),
        styleHead: "w-56 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="w-full truncate">${formatDate(item.bagCreatedAt)} <br/> ${item.bagCreatedName}</div>`;
        }
      },
      {
        name: this.$t("bagging.tableTitle.updatedBy"),
        styleHead: "w-56 text-left whitespace-no-wrap",
        render: (item: BaggingData) => {
          return `<div class="w-full truncate">${formatDate(item.bagUpdatedAt)} <br/> ${item.bagUpdatedName}</div>`;
        }
      },
      {
        name: "Action",
        key: "button_column",
        styleHead: "w-24 text-left",
        styleButton: (item: BaggingData) => {
          return {
            outline: true,
            icon: "option-gray",
            title: "",
            textColor: "black",
            color: "gray-lp-400",
            customClass: "button-option",
            clickFunction: () => null,
            groupOptions: [
              {
                icon: "printer",
                label: "Print PDF",
                clickFunction: async () => {
                  MainAppController.showLoading();
                  const printManifest = await BaggingController.getDetailBagging(
                    item.bagId
                  );
                  if (printManifest) {
                    const data = BaggingController.baggingDetail;
                    this.refs.print.printManifest(data);
                  }
                  MainAppController.closeLoading();
                }
              },
              {
                icon: "invoice",
                label: "Print Label",
                clickFunction: async () => {
                  MainAppController.showLoading();
                  const printLabel = await BaggingController.getDetailBagging(
                    item.bagId
                  );
                  if (printLabel) {
                    const bagVendorNo =
                      BaggingController.baggingDetail.bagVendorNo;
                    this.refs.print.printLabel(item, bagVendorNo);
                  }
                  MainAppController.closeLoading();
                }
              },
              {
                icon: "download-gray",
                label: "Download Excel",
                clickFunction: () => {
                  const data = {
                    id: item.bagId,
                    bagCode: item.bagCode
                  };
                  BaggingController.downloadBagging(data);
                }
              }
            ]
          };
        }
      }
    ];
  }

  chevronUp: boolean[] = [];

  get pagination() {
    return BaggingController.baggingList.pagination;
  }

  goToDetail(item: BaggingData) {
    this.$router.push(`/bagging/${item.bagId}?params=${item.bagCode}`);
  }

  get baggingList() {
    const data = BaggingController.baggingList.data;
    this.chevronUp = data.map(() => false);
    return data;
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get roleAccount() {
    return (
      (this.dataProfile.account_type === "partner"
        ? this.dataProfile.account_type_detail.type
        : this.dataProfile.account_type) || "internal"
    );
  }

  readyToProcess: BaggingData[] = [];
  readyToDelete: BaggingData[] = [];

  get bundleData() {
    return this.readyToProcess
      .concat(this.readyToDelete)
      .map((key: BaggingData) => {
        return {
          is_rtc: key.isAbleRTC,
          bag_id: key.bagId,
          bag_no: key.bagCode
        };
      });
  }

  get errorMessageBaggingRTC() {
    return BaggingController.errorMessageBaggingRTC;
  }

  get baggingDisputeSummary() {
    return BaggingController.baggingDisputeSummary;
  }

  get isBaggingDisputeSummaryHasPermission() {
    return FlagsPermissionBagging.permission_bagging_dispute_summary_enable.isEnabled();
  }

  sttsFailedData = [new BaggingRTCSttsFailedResponse()];
  async updateBaggingToRTC() {
    this.sttsFailedData = [new BaggingRTCSttsFailedResponse()];
    const payload = new PayloadUpdateReadyToCargo({ bagList: this.bundleData });
    await BaggingController.updateToRTCBagging(payload)
      .then((res: ResponsePayloadV2) => {
        this.showSuccessReadyToCargo();
      })
      .catch((err) => {
        const isSuccess = !err.response.data.success;
        const code = err.response.data.code;
        const isPartial = err.response.data.data?.is_partial;
        const showPartialError = isSuccess && code === 400 && isPartial;
        const isErrorBaggingRtcMessage =
          this.errorMessageBaggingRTC?.message || "";

        if (
          isErrorBaggingRtcMessage.includes(
            "Salah satu bag memiliki salah satu STT yang unpaid"
          )
        ) {
          this.showPopupSTTUnpaid();
          return;
        } else if (showPartialError) {
          this.sttsFailedData = err.response.data.data.stts_failed.map(
            (item: any) => {
              return new BaggingRTCSttsFailedResponse({
                bagNo: item.bag_no,
                stt: item.stt_no,
                errorMessage: item.error_message,
                lastStatus: item.last_status
              });
            }
          );
          this.showPartialSuccessModal();
          return;
        } else {
          this.showCancelReadyToCargo();
        }
      });
  }

  get titlePopupWording() {
    return `${
      this.readyToProcess.length
        ? this.$t("bagging.confirmRtcProcessTitle")
        : this.$t("bagging.confirmBaggingDeleteTitle")
    }`;
  }

  get subtitlePopupWording() {
    return `${
      this.readyToProcess.length
        ? this.$t("bagging.confirmRtcProcessMessage")
        : this.$t("bagging.confirmBaggingDeleteMessage")
    }`;
  }

  get titlePopupErrorWording() {
    return `${
      this.readyToProcess.length
        ? this.$t("bagging.rtcTitleErrorUpdate")
        : this.$t("bagging.rtcTitleErrorDelete")
    }`;
  }

  get subtitlePopupErrorWording() {
    return `${
      this.readyToProcess.length
        ? this.$t("bagging.rtcSubtitleErrorUpdate")
        : this.$t("bagging.rtcSubtitleErrorDelete")
    }`;
  }

  get today(): Date {
    return moment().toDate();
  }

  get yesterday(): Date {
    return moment()
      .subtract(1, "day")
      .toDate();
  }

  showPartialSuccessModal() {
    if(this.isAccountForeign) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          title: "Some bagging failed to be ready in cargo",
          image: "badge-warning-lg",
          message: "There is an invalid STT status in the bag. Please check & download the bag.",
          textCancel: "Back",
          textSuccess: "Download bag",
          onClose: () => {
            MainAppController.closeMessageModal();
          },
          onSubmit: () => {
            this.onDownloadXlsxFailedStt()
          }
        })
      );
    } else {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          title: "Beberapa bagging gagal siap di kargo",
          image: "badge-warning-lg",
          message: "Ada status STT dalam bag tidak valid. Silakan cek & download bag",
          textCancel: "Kembali",
          textSuccess: "Download bag",
          onClose: () => {
            MainAppController.closeMessageModal();
          },
          onSubmit: () => {
            this.onDownloadXlsxFailedStt()
          }
        })
      );
    }
  }

  get showPopuptoRTCWording() {
    return {
      titleTrue: this.$t("Lanjutkan Proses & Hapus ke Siap Dikargo?"),
      titleFalse: this.$t("Siap Dikargo?"),
      messageTrue: this.$t("Pastikan No. Bagging yang dipilih telah sesuai"),
      messageFalse: this.$t("Siap Dikargo"),
      back: this.$t("Kembali"),
      delete: this.$t("Hapus"),
      continue: this.$t("Lanjutkan")
    }
  }

  showPopupUpdateToReadyToCargo() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title:
          this.readyToProcess.length && this.readyToDelete.length
            ? this.showPopuptoRTCWording.titleTrue
            : `${this.titlePopupWording} ${this.showPopuptoRTCWording.titleFalse}`,
        image: "are-you-sure",
        message:
          this.readyToProcess.length && this.readyToDelete.length
            ? this.showPopuptoRTCWording.messageTrue
            : `${this.subtitlePopupWording} ${this.showPopuptoRTCWording.messageFalse}`,
        textCancel: this.showPopuptoRTCWording.back,
        textSuccess: this.readyToProcess.length ? this.showPopuptoRTCWording.continue : this.showPopuptoRTCWording.delete,
        onClose: () => {
          MainAppController.closeMessageModal();
        },
        onSubmit: () => {
          MainAppController.closeMessageModal();
          this.onShowLoadingSave();
        }
      })
    );
  }

  onDelaySave = debounce(() => {
    this.updateBaggingToRTC();
  }, 250);

  onShowLoadingSave() {
    MainAppController.showLoading();
    this.onDelaySave();
  }

  resetReadyToCargo() {
    MainAppController.closeMessageModal();
    this.fetchBaggingList();
    this.readyToDelete = [];
    this.readyToProcess = [];
  }

  showSuccessReadyToCargo() {
    if(this.isAccountForeign) {
      const onDeleteWording = this.readyToDelete.length ? 'and Deleted' : '';
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: this.readyToDelete.length && !this.readyToProcess.length ? "image-modal-success" : "rtc-background-process",
          title: this.readyToProcess.length
            ? `Bagging Will Be Processed ${onDeleteWording} RTC`
            : "Bagging No. Successfully Removed",
          message:
            this.readyToDelete.length && !this.readyToProcess.length
              ? "Bagging No. has been removed from the Ready to Cargo list"
              : `Please see your bagging during the cargo booking process.`,
          textSuccess: "OK",
          onSubmit: () => this.resetReadyToCargo()
        })
      );
    } else {
      const onDeleteWording = this.readyToDelete.length ? 'dan Dihapus' : '';
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: this.readyToDelete.length && !this.readyToProcess.length ? "image-modal-success" : "rtc-background-process",
          title: this.readyToProcess.length
            ? `Bagging Akan Diproses ${onDeleteWording} RTC`
            : "No. Bagging Berhasil Dihapus",
          message:
            this.readyToDelete.length && !this.readyToProcess.length
              ? "No. Bagging telah terhapus dari daftar Siap Dikargo"
              : `Silahkan lihat bagging Anda saat proses booking kargo`,
          textSuccess: "OK",
          onSubmit: () => this.resetReadyToCargo()
        })
      );
    }
  }

  showCancelReadyToCargo() {
    if(this.isAccountForeign) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "image-modal-failed",
          title:
            this.readyToProcess.length && this.readyToDelete.length
              ? "Add and Delete Bagging No. Failed"
              : `${this.titlePopupErrorWording}`,
          message:
            this.readyToProcess.length && this.readyToDelete.length
              ? "Add and delete Bagging No. failed."
              : `${this.subtitlePopupErrorWording} Ready to Cargo`,
          textSuccess: "OK",
          onSubmit: () => this.resetReadyToCargo()
        })
      );
    }
    else {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "image-modal-failed",
          title:
            this.readyToProcess.length && this.readyToDelete.length
              ? "Tambah dan Hapus No. Bagging Gagal"
              : `${this.titlePopupErrorWording}`,
          message:
            this.readyToProcess.length && this.readyToDelete.length
              ? "Tambah dan hapus No. Bagging gagal dilakukan."
              : `${this.subtitlePopupErrorWording} Siap DiKargo`,
          textSuccess: "OK",
          onSubmit: () => this.resetReadyToCargo()
        })
      );
    }
  }

  showPopupSTTUnpaid() {
    if(this.isAccountForeign) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "new-badge-failed",
          title: "Some Bagging No. Failed to Process",
          message: "There was an overweight and underpayment. Please wait until the customer settles the bill.",
          textSuccess: "OK",
          onSubmit: () => this.resetReadyToCargo()
        })
      );
    } else {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "new-badge-failed",
          title: "Beberapa No. Bagging Gagal Diproses ",
          message: "Terjadi kelebihan berat dan kurang bayar. Tunggu sampai customer melunasi tagihan",
          textSuccess: "OK",
          onSubmit: () => this.resetReadyToCargo()
        })
      );
    }
  }

  get downloadXlsx() {
    return {
      noBag: this.$t("Nomor Bag"),
      noStt: this.$t("Nomor STT"),
      status: this.$t("Status Terakhir STT/Bag"),
      reason: this.$t("Alasan Gagal")
    }
  }

  XLSX = XLSX;
  onDownloadXlsxFailedStt() {
    const data = this.XLSX.utils.json_to_sheet(
      this.sttsFailedData.map((d) => ({
        [this.downloadXlsx.noBag]: d.bagNo,
        [this.downloadXlsx.noStt]: d.stt,
        [this.downloadXlsx.status]: d.lastStatus,
        [this.downloadXlsx.reason]: d.errorMessage
      }))
    );
    const wb = this.XLSX.utils.book_new();
    this.XLSX.utils.book_append_sheet(wb, data, "bagging_stt_failed");
    this.XLSX.writeFile(wb, "bagging_stt_failed.xlsx");
  }
}
